import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { HelpdeskDialogComponent } from './helpdesk-dialog.component'

@NgModule({
    declarations: [HelpdeskDialogComponent],
    exports: [HelpdeskDialogComponent],
    imports: [CommonModule],
})
export class HelpdeskDialogModule {}
